export const defaultGlobalSettings = {
  header: {
    settings: {
      firstPart: ["search"],
      secondPart: [],
      thirdPart: ["profileButton", "search"],
    },
  },
  footer: {
    settings: {
      categories: [],
    },
  },
  menu: {
    settings: {
      categories: [],
      providers: [],
    },
  },
  mobileBar: {
    settings: {
      categories: [],
      items: [],
    },
  },
  support: {
    settings: {
      whatsapp: { enabled: false, href: "" },
      email: { enabled: false, href: "" },
      telegram: { enabled: false, href: "" },
      vk: { enabled: false, href: "" },
    },
  },
}
